import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { PROCESS } from "@/data/site";
import { FadeUp, Chapter, RevealLines, EASE } from "./motion";

export default function Process() {
  const lineRef = useRef(null);
  const inView = useInView(lineRef, { once: true, margin: "-100px" });

  return (
    <section id="process" data-testid="process-section" className="overflow-hidden bg-[#E7DDD0]/50 py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Chapter num="04" title="The Process" />
        <div className="mt-8 flex flex-wrap items-end justify-between gap-6">
          <RevealLines
            className="font-display text-4xl tracking-tight text-[#1B1B1B] md:text-6xl"
            lines={[<>Seven steps to</>, <>the <span className="italic text-[#B68D40]">final reveal.</span></>]}
          />
        </div>

        <div ref={lineRef} className="relative mt-20">
          <motion.div
            className="absolute left-0 top-6 hidden h-px bg-[#B68D40] lg:block"
            initial={{ width: "0%" }}
            animate={inView ? { width: "100%" } : {}}
            transition={{ duration: 2.4, ease: EASE, delay: 0.3 }}
          />
          <div className="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-7 lg:gap-4">
            {PROCESS.map((p, i) => (
              <FadeUp key={p.step} delay={0.3 + i * 0.22} className="relative">
                <div data-testid={`process-step-${i}`} className="group">
                  <div className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-[#B68D40] bg-[#F7F5F2] font-num text-sm font-semibold text-[#B68D40] transition-colors duration-300 group-hover:bg-[#B68D40] group-hover:text-[#F7F5F2]">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <h3 className="mt-5 font-display text-lg text-[#1B1B1B]">{p.step}</h3>
                  <p className="mt-2 text-xs leading-relaxed text-[#2C2C2C]/60">{p.desc}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
